export default __webpack_public_path__ + "static/media/download_methodiek_bevraging.bb36f9c7.pdf";